import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ChevronLeft, Trash2 } from "lucide-react";
import { toast } from "sonner";

import { api } from "../lib/api";
import Results from "./Results";
import { Button } from "../components/ui/button";

// Reuses the Results layout but with a delete action attached.
export default function SessionDetail() {
    const { sessionId } = useParams();
    const navigate = useNavigate();
    const [exists, setExists] = useState(true);

    useEffect(() => {
        api.get(`/sessions/${sessionId}`).catch(() => setExists(false));
    }, [sessionId]);

    const remove = async () => {
        if (!window.confirm("Delete this session permanently?")) return;
        try {
            await api.delete(`/sessions/${sessionId}`);
            toast.success("Session removed");
            navigate("/history", { replace: true });
        } catch {
            toast.error("Could not delete");
        }
    };

    if (!exists) {
        return (
            <div className="max-w-2xl mx-auto px-5 sm:px-8 pt-12 text-center" data-testid="session-detail-missing">
                <div className="font-serif text-3xl italic text-stone-500">This session is gone.</div>
                <Link to="/history" className="inline-flex mt-6 items-center gap-1 text-sm text-terracotta">
                    <ChevronLeft size={16} /> Back to history
                </Link>
            </div>
        );
    }

    return (
        <div data-testid="session-detail-page">
            <Results />
            <div className="max-w-3xl mx-auto px-5 sm:px-8 pb-2 -mt-4">
                <Button
                    variant="ghost"
                    onClick={remove}
                    className="rounded-full text-red-600 hover:text-red-700 hover:bg-red-50 dark:hover:bg-red-950"
                    data-testid="session-delete-btn"
                >
                    <Trash2 size={14} className="mr-1.5" /> Delete this session
                </Button>
            </div>
        </div>
    );
}
